import { render, staticRenderFns } from "./TemplateBenefits.vue?vue&type=template&id=6f743f4d&scoped=true&"
import script from "./TemplateBenefits.vue?vue&type=script&setup=true&lang=ts&"
export * from "./TemplateBenefits.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./TemplateBenefits.vue?vue&type=style&index=0&id=6f743f4d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f743f4d",
  null
  
)

export default component.exports